// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__gyGws","col":"CardReaderDesc_col__3ThNX","label":"CardReaderDesc_label__2z6_X"};